import React, { useState } from 'react';
import { PiEyeThin, PiEyeSlashThin } from 'react-icons/pi';
import '../../styles/PasswordInput.css';
interface PasswordInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  minLen?: number;
  maxLen?: number;
  autoComplete?: string;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder,
  className = '',
  id,
  minLen,
  maxLen,
  autoComplete,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={`password-input-container ${className}`}>
      <input
        type={showPassword ? 'text' : 'password'}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="password-input-field"
        min={minLen}
        max={maxLen}
        autoComplete={autoComplete}
      />
      <span
        onClick={togglePasswordVisibility}
        role="button"
        tabIndex={0}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            togglePasswordVisibility();
          }
        }}
        className="password-input-icon"
      >
        {showPassword ? <PiEyeSlashThin size={24} /> : <PiEyeThin size={24} />}
      </span>
    </div>
  );
};

export default PasswordInput;
